import './memberJoin';
import initProcessPayment from './processPayment';

$(() => {
  initProcessPayment();
});
